<template>
  <v-menu
    v-if="routeName === 'users-show'"
    v-model="vMenu"
    :close-on-content-click="false"
    :close-on-click="false"
    :nudge-width="$vuetify.breakpoint.mdAndUp ? 370 : 200"
    open-delay
    max-width="400"
    offset-x
    offset-y
    nudge-bottom="14"
    content-class="note-menu"
  >
    <template
      #activator="{ on, attrs }"
    >
      <v-badge
        bottom
        left
        overlap
        class="ml-4 fa-font v-chip-light-bg"
        :content="String(notes.length)"
        offset-y="9"
        offset-x="9"
      >
        <v-icon
          v-bind="attrs"
          v-on="on"
        >
          {{ icons.mdiNotePlusOutline }}
        </v-icon>
      </v-badge>
    </template>
    <v-card>
      <v-card-text>
        <v-skeleton-loader
          v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <template v-else>
          <v-card-title>
            <v-row>
              <div>
                <v-btn
                  icon
                  small
                  class="ml-2"
                  color="error"
                  @click="closeMenu()"
                >
                  <v-icon
                    size="18"
                  >
                    {{ icons.mdiClose }}
                  </v-icon>
                </v-btn>
                <span style="font-size: 14px">پیام ها</span>
              </div>
            </v-row>
          </v-card-title>
          <v-card-text>
            <perfect-scrollbar
              class="ps-list"
            >
              <v-simple-table>
                <template #default>
                  <tbody v-if="notes.length > 0">
                    <tr
                      v-for="(note, index) in notes"
                      :key="index"
                    >
                      <td style="width: 30% !important;">
                        {{ note.user.name || note.user.mobile_number }}
                        <div class="text-xs">
                          {{ note.created_at | moment(`jD jMMMM jYYYY ${$t('Hour')} HH:mm`) }}
                        </div>
                      </td>
                      <td class="text-center">
                        {{ shortenText(note.content, 10) }}
                      </td>
                      <td class="text-left">
                        <v-tooltip
                          bottom
                        >
                          <template #activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="show(note)"
                            >
                              <v-icon
                                size="16"
                              >
                                {{ icons.mdiEye }}
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>مشاهده</span>
                        </v-tooltip>
                        <template v-if="$store.state.user.id === note.user.id">
                          <v-tooltip
                            bottom
                            color="warning"
                          >
                            <template #activator="{ on, attrs }">
                              <v-btn
                                icon
                                small
                                v-bind="attrs"
                                v-on="on"
                                @click="toggleEditMode(note)"
                              >
                                <v-icon
                                  size="16"
                                  color="warning"
                                >
                                  {{ icons.mdiPencil }}
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>ویرایش</span>
                          </v-tooltip>
                          <v-tooltip
                            bottom
                            color="error"
                          >
                            <template #activator="{ on, attrs }">
                              <v-btn
                                icon
                                small
                                v-bind="attrs"
                                v-on="on"
                                @click="openDeleteModal(note)"
                              >
                                <v-icon
                                  size="16"
                                  color="error"
                                >
                                  {{ icons.mdiDeleteOutline }}
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>حذف</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </perfect-scrollbar>
            <v-divider
              v-if="notes.length > 0"
              class="mb-2 mt-2"
            ></v-divider>
            <v-row class="mt-2">
              <v-col cols="12">
                <span v-if="!isEditMode">افزودن یادداشت</span>
                <span v-else>ویرایش یادداشت</span>
              </v-col>
              <v-col cols="12">
                <v-form
                  ref="formRef"
                  @submit.prevent="send"
                >
                  <v-textarea
                    v-model="text"
                    placeholder="متن خود را وارد کنید"
                    dense
                    outlined
                    class="size-3"
                    :rules="[validators.required]"
                  ></v-textarea>
                  <div class="float-left">
                    <v-btn
                      v-if="isEditMode"
                      color="error"
                      outlined
                      small
                      class="ml-2"
                      @click="cancel()"
                    >
                      {{ $t('Cancel') }}
                    </v-btn>
                    <v-btn
                      v-if="!isEditMode"
                      color="primary"
                      :loading="btnLoading"
                      small
                      type="submit"
                    >
                      {{ $t('Save') }}
                    </v-btn>
                    <v-btn
                      v-else
                      color="warning"
                      small
                      :loading="btnLoading"
                      type="submit"
                    >
                      ویرایش
                    </v-btn>
                  </div>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="isVisibleModal"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-text style="text-align: center;margin-top: 5px;">
          <v-row v-if="row">
            <v-col cols="12">
              <div
                class="mb-4 text-right"
              >
                <span v-html="row.content"></span>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              outlined
              small
              @click="closeModal()"
            >
              بستن
            </v-btn>
          </v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <delete-modal
      message="آیا از حذف این یادداشت مطمئن هستید؟"
      :is-visible="isModalDeleteVisible"
      :loading="btnDeleteLoading"
      @close="isModalDeleteVisible = false"
      @confirm="callRemoveService"
    >
    </delete-modal>
  </v-menu>
</template>
<script>
// eslint-disable-next-line object-curly-newline
import { ref, defineComponent, watch, computed, onMounted } from '@vue/composition-api'
// eslint-disable-next-line object-curly-newline
import {
  mdiNotePlusOutline,
  mdiArrowLeft,
  mdiPencil,
  mdiDeleteOutline,
  mdiShieldAlertOutline,
  mdiEye,
  mdiClose,
} from '@mdi/js'
import { required } from '@core/utils/validation'
import { useRouter } from '@core/utils'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import DeleteModal from '@/components/modals/DeleteModal.vue'
import useMixin from '@/view-composables/common/useMixin'
import noteService from './noteService'

export default defineComponent({
  name: 'AppBarNote',
  components: { DeleteModal, PerfectScrollbar },
  setup() {
    const text = ref('')
    const { shortenText } = useMixin()
    const { route } = useRouter()
    const formRef = ref(null)
    const vMenu = ref(false)
    const isModalDeleteVisible = ref(false)
    const btnLoading = ref(false)
    const isEditMode = ref(false)
    const isVisibleModal = ref(false)
    const btnDeleteLoading = ref(false)
    const row = ref(null)
    const { notes, loading, fetch } = noteService()
    const routeName = computed(() => route.value.name)
    const resetValidation = () => {
      formRef.value.resetValidation()
    }

    const openDeleteModal = note => {
      isModalDeleteVisible.value = true
      row.value = note
    }

    const getNote = () => {
      isEditMode.value = false

      const params = {
        route: route.value.fullPath,
      }
      fetch(params)
    }

    const show = note => {
      row.value = note
      isVisibleModal.value = true
    }

    const closeModal = () => {
      row.value = null
      isVisibleModal.value = false
    }

    const toggleEditMode = note => {
      isEditMode.value = true
      row.value = note
      text.value = note.content
    }

    const clear = () => {
      resetValidation()
      text.value = ''
      isEditMode.value = false
      isModalDeleteVisible.value = false
      row.value = null
    }

    const cancel = () => {
      isEditMode.value = false
      clear()
    }

    const closeMenu = () => {
      vMenu.value = false
      clear()
    }

    const reload = () => {
      clear()
      getNote()
    }

    const send = async () => {
      const isFormValid = formRef.value.validate()

      if (!isFormValid) return

      btnLoading.value = true

      const params = {
        route: route.value.fullPath,
        content: text.value,
      }

      if (!isEditMode.value) {
        await noteService(btnLoading).add(params, reload)
      } else {
        await noteService(btnLoading).edit(row.value.id, params, reload)
      }
    }

    const afterRemove = () => {
      getNote()
      row.value = null
      isModalDeleteVisible.value = false
    }

    const callRemoveService = () => {
      noteService().remove(row.value.id, afterRemove, btnDeleteLoading)
    }

    watch(routeName, currentValue => {
      if (currentValue == 'users-show') {
        getNote()
      }
    })

    onMounted(() => {
      if (routeName.value == 'users-show') {
        getNote()
      }
    })

    return {
      text,
      isVisibleModal,
      notes,
      cancel,
      toggleEditMode,
      loading,
      formRef,
      isEditMode,
      fetch,
      clear,
      send,
      shortenText,
      routeName,
      row,
      btnLoading,
      isModalDeleteVisible,
      openDeleteModal,
      callRemoveService,
      btnDeleteLoading,
      closeModal,
      getNote,
      vMenu,
      show,
      closeMenu,
      validators: {
        required,
      },
      icons: {
        mdiNotePlusOutline,
        mdiShieldAlertOutline,
        mdiArrowLeft,
        mdiPencil,
        mdiDeleteOutline,
        mdiEye,
        mdiClose,
      },
    }
  },
})
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .v-menu__content {
    max-width: 100% !important;
    top: 55px !important;
    left: 0px !important;
    right: 0px !important;
  }
}

.ps-list {
  max-height: 184px;
}
</style>
